import * as React from 'react';
import { SVGProps } from 'react';
const CreateIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="13"
    height="13"
    viewBox="0 0 13 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.53125 5.46875V5.96875H7.03125H11.7188C11.7933 5.96875 11.8649 5.99838 11.9176 6.05113L12.2712 5.69757L11.9176 6.05113C11.9704 6.10387 12 6.17541 12 6.25C12 6.32459 11.9704 6.39613 11.9176 6.44887L12.2712 6.80243L11.9176 6.44888C11.8649 6.50162 11.7933 6.53125 11.7188 6.53125H7.03125H6.53125V7.03125V11.7188C6.53125 11.7933 6.50162 11.8649 6.44888 11.9176L6.80243 12.2712L6.44887 11.9176C6.39613 11.9704 6.32459 12 6.25 12C6.17541 12 6.10387 11.9704 6.05113 11.9176L5.69757 12.2712L6.05113 11.9176C5.99838 11.8649 5.96875 11.7933 5.96875 11.7188V7.03125V6.53125H5.46875H0.78125C0.706657 6.53125 0.63512 6.50162 0.582377 6.44887C0.529632 6.39613 0.5 6.32459 0.5 6.25C0.5 6.17541 0.529632 6.10387 0.582376 6.05113C0.635121 5.99838 0.706658 5.96875 0.78125 5.96875H5.46875H5.96875V5.46875V0.78125C5.96875 0.706658 5.99838 0.635121 6.05113 0.582377C6.10387 0.529632 6.17541 0.5 6.25 0.5C6.32459 0.5 6.39613 0.529632 6.44887 0.582377C6.50162 0.63512 6.53125 0.706657 6.53125 0.78125V5.46875Z"
      fill="#7C98B6"
      stroke="#475CB0"
    />
  </svg>
);
export default CreateIcon;
